<div class="modal-body text-center top-radious">
  <i class="fa fa-close" (click)="modalRef.hide()"></i>
  <div class="display-flex-left">
    <div class="left" *ngIf="content">
      <p class="title" *ngIf="content.Title">{{ content?.Title }}</p>
      <button
        (click)="setImage('rolling')"
        [ngClass]="{ active: currImage == 'rolling' }"
        type="button"
        name="button"
      >
        {{ content?.CorrectionsRollingBtn }}
      </button>
      <button
        (click)="setImage('plan')"
        [ngClass]="{ active: currImage == 'plan' }"
        type="button"
        name="button"
      >
        {{ content?.CorrectionsPlanEndBtn }}
      </button>
    </div>
    <div class="right">
      <img [src]="getHelpImage()" alt="" />
    </div>
  </div>
</div>
